import { Link, useLocation } from "react-router-dom";
import { useSoundPath } from "hooks/useSoundPath";

const MainTabs = ({ tabs }) => {
  const { pathname } = useLocation();
  const playSound = useSoundPath();
  const onClickScreenScale = () => (document.body.style.zoom = "100%");

  return (
    <div className="main-tabs">
      <nav className="main-tabs__wrapper">
        {tabs.map((tab) => {
          return (
            <Link
              to={tab.url}
              key={tab.url}
              className={`main-tabs__item ${
                pathname.includes(tab.url.split("?")[0]) ? "active" : ""
              }`}
              onClick={() => {
                playSound("nav");
                onClickScreenScale();
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default MainTabs;
